import { isPortal } from 'vet-bones/utils/portal';

import { getConnectionFromApi } from 'src/browser/utils/getConnectionFromApi';
import { connectionActionCreators } from 'src/common/actions/connection/connectionActionCreators';
import {
  StudioStateGetter,
  StudioThunkDispatch,
} from 'src/common/actions/StudioAction';

export const refreshConnectionToken =
  () => async (dispatch: StudioThunkDispatch, getState: StudioStateGetter) => {
    const { connection } = getState();
    const { current: currentConnection } = connection;

    if (!isPortal() || !currentConnection?.token) {
      return null;
    }
    const updatedConnection = await getConnectionFromApi();

    if (!updatedConnection?.token) {
      return null;
    }

    dispatch(
      connectionActionCreators.updateConnectionToken(updatedConnection.token)
    );

    return { ...currentConnection, token: updatedConnection.token };
  };
